export const CONSTANTS = {
    WELCOME_MESSAGE: 'Welcome to 2290.ai — the easiest way to file your Form 2290! We simplify HVUT filings, ensure IRS compliance, offer instant Schedule 1 access, and support secure payments. Ready to see how fast you can file? Just ask me anything or type "Get Started"!',
    TAX1099_WELCOME_MESSAGE: '👋Welcome to Tax1099! I’m here to make IRS e-filing fast, accurate, and stress-free. Whether you’re filing 1099s, W-2s, or ACA forms, I’ll guide you step-by-step, prevent costly errors, and keep you compliant with deadlines. Ready to save up to 82% of your time and file with confidence? 🚀'
}


export const SALES_BOT_NAME = 'salesBot2290AI';
export const TAX1099_SALES_BOT_NAME = 'salesBotTax1099';
export const SALES_PRODUCT_NAME = '2290.ai';
export const TAX1099_SALES_PRODUCT_NAME = 'Tax1099'
export const SALES_STATUS = 'New';
export const SALES_ORIGIN = 'AI Chatbot';
export const SALES_TYPE = 'Sales Lead';
export const SALES_REASON = 'New problem';
export const SALES_QUERY_TYPE = 'Sales Lead';
export const TAX1099_SUPPORT_TYPE = 'Question';
export const TAX1099_SUBJECT= 'Testing';

export const SALES_DESCRIPTION = (numberOfForms: string) =>
  `Customer interested in filling ${numberOfForms} form from our 2290.ai website. Contact for converting the user`;
export const TAX1099_SALES_DESCRIPTION = (numberOfForms: string) =>
  `Customer interested in filling ${numberOfForms} form from our Tax1099 website. Contact for converting the user`;

export const SALES_SUBJECT = (numberOfForms: string) =>
  `Lead Generated for sales ${numberOfForms}`;

export const SALES_PROMPT = `Let’s start this journey together! Share your email and I’ll walk you through the next steps to get you moving in the right direction. 🚀`;

export const SALES_UI_TEXT = {
  EMAIL_LABEL: 'Email Address',
  EMAIL_PLACEHOLDER: 'Enter Email Address',

  FORMS_LABEL: 'Number of Vehicles',
  TAX1099_FORMS_LABEL: 'Number of Forms',
  FORMS_PLACEHOLDER: 'Enter Number of Vehicles',
  TAX1099_FORMS_PLACEHOLDER : 'Enter Number of Forms',
  BOOK_A_DEMO: 'To book your demo, please fill out the form below',
  DISCOUNTED_PRICING: 'To request a custom quote for bulk filings, please fill out the form below',
  SALES_FLOW_BELOW500: 'If you’d like, you can book a group demo to see how everything works.',
  SALES_FLOW_BELOW1000: 'If you’d like, you can talk to a live agent to better understand the platform.',
  SALES_FLOW_ABOVE1000: 'If you’d like, you can book a personalized demo tailored to your needs.',

  SUBMIT_BUTTON_LABEL: 'Submit',
};

export const LOCAL_STORAGE_KEYS = {
  userNumber: 'userNumber',
  userEmail: 'userEmail',
};

export const SALESBOT2290_UI_TEXT = {
  CARD_TITLE: 'Fill in the details to estimate your 2290 tax',
  EMAIL_LABEL: 'Email Address',
  EMAIL_PLACEHOLDER: 'Enter Email Address',
  MONTH_LABEL: 'Month',
  LOGGING_LABEL: 'Logging',
  WEIGHT_LABEL: 'Weight',
  SELECT_PLACEHOLDER: 'Select',
  SUBMIT_BUTTON_LABEL: 'Calculate Now',
};

export const SALESBOT2290_MONTH_OPTIONS: { name: string; value: string }[] = [
  { name: 'January', value: '1' },
  { name: 'February', value: '2' },
  { name: 'March', value: '3' },
  { name: 'April', value: '4' },
  { name: 'May', value: '5' },
  { name: 'June', value: '6' },
  { name: 'July', value: '7' },
  { name: 'August', value: '8' },
  { name: 'September', value: '9' },
  { name: 'October', value: '10' },
  { name: 'November', value: '11' },
  { name: 'December', value: '12' },
];

export const SALESBOT2290_LOGGING_OPTIONS = [
  { name: 'Yes', value: 'true' },
  { name: 'No', value: 'false' },
];
